import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../css/style.css";
import "../css/login1.css";
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import OtpInput from "react-otp-input";
import { subApi, unsubApi } from "../../services/user-api";
import {
  serviceId,
  Loader,
  countryCode,
  flag,
  Popup,
  PopupSub,
} from "../../utils/constant";
import ReCAPTCHA from "react-google-recaptcha";

const Ecoz = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [popupLoader, setPopupLoader] = useState(false);
  const [flowLoading, setFlowLoading] = useState(false);
  const [subMsg, setSubMsg] = useState("");
  const [flow, setFlow] = useState("");
  const [phone, setPhone] = useState(sessionStorage.getItem("ugAlias"));
  const [subOption, setSubOption] = useState(1);
  const [plan, setPlan] = useState(1);
  const [currency, setCurrency] = useState("USD");
  const currencyList = [
    { value: "USD", label: "USD" },
    { value: "ZIG", label: "ZWG" },
  ];
  const [price, setPrice] = useState({
    ZIG: ["2.02 ZWG/Day", "8.08 ZWG/Week", "24.25 ZWG/Month"],
    USD: ["0.05 USD/Day", "0.23 USD/Week", "0.75 USD/Month"],
  });
  const [message, setMessage] = useState({ message: "", error: false });
  const [otpId, setOtpId] = useState("");
  const [otp, setOtp] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [subStatus, setSubStatus] = useState(0);
  const [popup, setPopup] = useState(false);
  const [ButtonDisabled, setButtonDisabled] = useState(true);
  const [ButtonLoginDisabled, setButtonLoginDisabled] = useState(true);
  const msgInprocess =
    "Your subscription request has been received and is being processed. You will receive a confirmation via SMS";
  const msgLowbalance =
    "You have insufficient balance. Please recharge your number and try again to access this service.";
  useEffect(() => {
    let timer = null;
    if (isActive) {
      setSeconds(0);
      timer = setInterval(() => {
        setSeconds((seconds) => {
          if (seconds < 60) return seconds + 1;
          else {
            clearInterval(timer);
            setIsActive(false);
            return seconds;
          }
        });
      }, 1000);
    }
    return () => {
      clearInterval(timer);
    };
  }, [isActive]);

  useEffect(() => {
    var nm = 0;
    if (phone) {
      setButtonDisabled(false);
      nm = phone;
      if (nm.length <= 10) nm = countryCode + nm;
      if (phone.length > 9) setPhone(phone.substring(3, phone.length));
    }
    const token = sessionStorage.getItem("token");
    if (!token) {
      setFlow("");
    } else {
      setFlow("PACK");
      setFlowLoading(true);
      subApi({ action: 0, ani: nm, serviceId: serviceId })
        .then((res) => {
          setFlowLoading(false);
          if (res.data.data !== null && res.data.data !== undefined) {
            if (res.data.status === 1 || res.data.status === 2) {
              setPlan(res.data.data);
              setFlow("UNSUB");
            }
          }
        })
        .catch((err) => {
          console.log(err);
          setFlowLoading(false);
        });
    }
  }, []);

  const sendOtp = async () => {
    console.log("phone=" + phone);
    setMessage({ message: "", error: false });
    if (isCatchaVerified) {
      setIsActive(false);
      if (phone && phone.length >= 8) {
        var nm = phone;
        if (nm.length <= 10) nm = countryCode + nm;
        setPopupLoader(true);
        await subApi({ action: 3, serviceId: serviceId, ani: nm })
          .then((res) => {
            //await subApi({action:0,ani: nm,serviceId:serviceId}).then((res) => {
            if (res.status === 200) {
              if (res.data.responseCode === 207) {
                setSubStatus(207);
                setPopup(true);
              } else {
                setIsActive(true);
                setOtpId(res.data.data);
              }
            }
            setPopupLoader(false);
          })
          .catch((err) => {
            console.log(err);
            //setFlow("PACK");
            setMessage({ message: err.message, error: true });
            setPopupLoader(false);
          });
      } else if (phone && phone.length > 0) {
        setMessage({ message: "Please enter a valid number", error: true });
      } else {
        setMessage({ message: "Please enter a number", error: true });
      }
    } else {
      setMessage({ message: "Please verify captcha.", error: true });
    }
  };

  const confirmOtp = async () => {
    setMessage({ message: "", error: false });
    if (isCatchaVerified) {
      if (otp != null && otp.length === 4) {
        var nm = phone;
        if (nm.length < 10) nm = countryCode + nm;
        setLoading(true);
        await subApi({
          action: 4,
          serviceId: serviceId,
          ani: nm,
          otpId: otpId,
          otp: otp,
        })
          .then((res) => {
            if (res.status === 200) {
              sessionStorage.setItem("ugAlias", nm);
              sessionStorage.setItem("token", res.data.data.accessToken);
              window.location.href = "/home";
            } else {
              setMessage({ message: res.data.message, error: true });
            }
          })
          .catch((err) => {
            setMessage({ message: err.message, error: true });
          })
          .finally(() => setLoading(false));
      } else {
        setMessage({ message: "You have entered an invalid OTP", error: true });
      }
    } else {
      setMessage({ message: "Please verify captcha.", error: true });
    }
  };

  const subscribe = async () => {
    setPopup(false);
    setPopupLoader(true);
    var nm = 0;
    if (phone) {
      nm = phone;
      if (nm.length < 10) nm = countryCode + nm;
    }
    await subApi({
      action: 1,
      serviceId: serviceId,
      planId: plan,
      ani: nm,
      mode: "WAP",
      otpId: otpId,
      type: currency,
    })
      .then((res) => {
        setPopupLoader(false);
        setMessage({ message: msgInprocess, error: false });
        setSubStatus(102);
        setPopup(true);
      })
      .catch((err) => {
        console.log(err);
        setPopupLoader(false);
        setMessage({ message: err.message, error: true });
        setSubStatus(102);
        setPopup(true);
      });
  };
  const unsub = async (insput) => {
    setPopup(false);
    setPopupLoader(true);
    await unsubApi({ action: 2, serviceId: serviceId, mode: "WAP" })
      .then((res) => {
        setPopupLoader(false);
        setMessage({
          message: "You are successfully unsubscribed from the service.",
          error: false,
        });
        setSubStatus(102);
        setPopup(true);
      })
      .catch((err) => {
        console.log(err);
        setPopupLoader(false);
        setMessage({ message: err.message, error: true });
        setSubStatus(102);
        setPopup(true);
      });
  };
  const logout = async (insput) => {
    setPopup(false);
    setPopupLoader(true);
    await unsubApi({ action: 11, serviceId: serviceId, mode: "WAP" })
      .then((res) => {
        setPopupLoader(false);
        setPopup(false);
        sessionStorage.clear();
        window.location.href = "/login";
      })
      .catch((err) => {
        console.log(err);
        setPopupLoader(false);
        setMessage({ message: err.message, error: true });
        setSubStatus(102);
        setPopup(true);
      });
  };

  const clearSession = async () => {
    setPopup(false);
    if (phone && phone.length >= 8) {
      var nm = phone;
      if (nm.length <= 10) nm = countryCode + nm;
      await subApi({ action: 11, serviceId: serviceId, ani: nm })
        .then((res) => {
          console.log("Session cleared successfully");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleNumberChange = async (event) => {
    setIsActive(false);
    setMessage({ message: "", error: false });
    const input = event.target.value;
    if (input.length < 11) setPhone(input);
    setButtonDisabled(input.length < 8);
    if (otp.length >= 4 && input.length >= 8) setButtonLoginDisabled(false);
    else setButtonLoginDisabled(true);
  };
  const handleOtpChange = async (event) => {
    setMessage({ message: "", error: false });
    const input = event.target.value;
    if (input.length < 5) setOtp(input);
    //console.log(phone+"::"+phone.length);
    if (input.length >= 4 && phone.length >= 8) setButtonLoginDisabled(false);
    else setButtonLoginDisabled(true);
  };

  const cancel = async (input) => {
    setMessage({ message: "", error: false });
    setPhone("");
    setFlow(input);
  };
  const handleNumInputsChange = (numInputs) => {
    setOtp(numInputs);
    setButtonDisabled(numInputs.length !== 4 || isNaN(numInputs));
  };
  const redirectTo = async (input) => {
    if (input === "/home") {
      //checkStatus();
      setFlow("SUCCESS");
    } else if (input === "/main") {
      setPopup(false);
      navigate("/home");
    } else if (input === "/cancel") {
      setPopup(false);
    } else if (input === "/logout") {
      logout();
    } else if (input === "/clearSession") {
      clearSession();
    } else navigate(input);
  };
  // ##################### google catcha ######################
  const [isCatchaVerified, setIsCatchaVerified] = useState(false);
  const recaptchaRef = useRef(null);

  const handleRecaptchaChange = (token) => {
    setMessage({ message: "", error: false });
    setIsCatchaVerified(!!token);
  };

  const handleReset = () => {
    setMessage({ message: "", error: false });
    recaptchaRef.current?.reset();
    setIsCatchaVerified(false);
  };

  const handleSubmit = () => {
    if (isCatchaVerified) {
      alert("Captcha verified! Form submitted!");
    } else {
      alert("Please verify the captcha.");
    }
  };

  return flowLoading ? (
    <Loader />
  ) : (
    <>
      <div className="home">
        <div className="maine-div">
          <div className="container-fluid box-wrapper login">
            <div className="login-header pb-4">
              <div className="box-wrapper mx-auto text-center position-relative">
                <span className="modal-level-title game-title">
                  Dive into the world of YoGamezBox! More than 1,000 games await
                  you for an immersive and fun experience 🌟. Climb the rankings
                  📈 and be among the top winners every day, every week and
                  every month to receive exclusive rewards 🏆. play without
                  limits and aim for the top of the leaderboard 🔝!
                </span>
              </div>
            </div>
            <div className="login-info">
              <div className="login-thumbnail3">
                <img src="/images/login_img_new.png" alt="YoGamez" />
              </div>

              {flow === "PACK" ? (
                <>
                  <h3 className="login-title mt-3 text-center">
                    Welcome to YoGamezBox
                  </h3>

                  <div className="text-center radio">
                    {currencyList.map((item, index) => (
                      <label key={`rc${index}`}>
                        <input
                          key={`inrc${index}`}
                          type="radio"
                          id={`rcr${index + 1}`}
                          value={item.value}
                          checked={currency === item.value}
                          onChange={(e) => setCurrency(e.target.value)}
                        />
                        {item.label}
                      </label>
                    ))}
                    <hr />
                    <h3 className="header-title-green mb-3 mt-3 text-center">
                      Select subscription pack
                    </h3>
                    {price[currency].map((item, index) => (
                      <div key={`di${index}`}>
                        <label key={`rd${index}`}>
                          <input
                            key={`inrd${index}`}
                            type="radio"
                            id={`rd${index + 1}`}
                            value={index + 1}
                            checked={plan === index + 1}
                            onChange={(e) => setPlan(parseInt(e.target.value))}
                          />
                          {item}
                        </label>
                        <br />
                      </div>
                    ))}
                  </div>
                  <div className="text-center phone-info">
                    {loading ? (
                      <Loader />
                    ) : (
                      <>
                        <button
                          className="btn btn-primary btn-pm-custom"
                          type="button"
                          onClick={() => {
                            setSubStatus(101);
                            setPopup(true);
                          }}
                        >
                          Subscribe Now
                        </button>
                        <div className="popupDiv col-12">
                          <button
                            className="btn btn-primary btn-pm-red"
                            type="button"
                            onClick={() => navigate("/home")}
                          >
                            CANCEL
                          </button>
                          &nbsp;&nbsp;
                          <button
                            className="btn btn-primary btn-pm-green"
                            type="button"
                            onClick={() => {
                              setSubStatus(104);
                              setPopup(true);
                            }}
                          >
                            LOGOUT
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              ) : flow === "OTPCONFIRM" ? (
                <>
                  <h3 className="login-title mb-3 mt-3 text-center">
                    Enter OTP
                  </h3>
                  <div className="phone-info">
                    <div className="otp_section">
                      <OtpInput
                        value={otp}
                        numInputs={4}
                        renderInput={(props, index) => (
                          <input {...props} type="tel" inputMode="numeric" />
                        )}
                        inputStyle="form-control form-otp"
                        onChange={handleNumInputsChange}
                      />
                    </div>
                    {message.message && (
                      <div className="mb-3">
                        <p
                          className={`alert alert-${message.error ? "danger" : "success"}`}
                        >
                          {message.message}
                        </p>{" "}
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <button
                        className="btn btn-primary btn-pm-custom"
                        type="button"
                        onClick={confirmOtp}
                        disabled={ButtonDisabled}
                      >
                        Confirm
                      </button>
                    )}
                    <div className="resend_otp">
                      <a
                        className="send_otp_link"
                        onClick={() => {
                          cancel("");
                        }}
                      >
                        {" "}
                        &lt;&lt;&nbsp;Back
                      </a>
                    </div>
                  </div>
                </>
              ) : flow === "ALREADYLOGIN" ? (
                <>
                  <div className="mb-3">
                    <p className="alert alert-danger">
                      You are already logged in on another device. Do you want
                      to continue and log out from other sessions?
                    </p>{" "}
                    <button
                      className="btn btn-primary btn-pm-green"
                      type="button"
                      onClick={logout}
                    >
                      YES
                    </button>
                    <button
                      className="btn btn-primary btn-pm-red"
                      type="button"
                      onClick={() => setFlow("")}
                    >
                      NO
                    </button>
                  </div>
                </>
              ) : flow === "CONFIRM" ? (
                <>
                  <h3 className="login-title mb-3 mt-3 text-center">
                    You are about to register for the YoGamezBox for{" "}
                    <span className="span-bold">{price[plan]}</span>{" "}
                    automatically renewable
                  </h3>
                  <h3 className="login-title mb-3 mt-3 text-center">
                    Are you sure you want to continue?
                  </h3>
                  {message.message && (
                    <div className="mb-3">
                      <p
                        className={`alert alert-${message.error ? "danger" : "success"}`}
                      >
                        {message.message}
                      </p>{" "}
                    </div>
                  )}
                  {loading ? (
                    <Loader />
                  ) : (
                    <button
                      className="btn btn-primary btn-pm-green"
                      type="button"
                      onClick={subscribe}
                    >
                      YES
                    </button>
                  )}
                  <button
                    className="btn btn-primary btn-pm-red"
                    type="button"
                    onClick={() => setFlow("")}
                  >
                    NO
                  </button>
                </>
              ) : flow === "UNSUB" ? (
                <>
                  <h3 className="login-title mb-3 mt-3 text-center">
                    You are subscribed for <br />
                    <span className="span-bold">{price[plan]}</span> pack.
                    <br /> To unsubscribe click on unsubscribe button.
                  </h3>
                  <button
                    className="btn btn-primary btn-pm-custom"
                    type="button"
                    onClick={() => {
                      setSubStatus(103);
                      setPopup(true);
                    }}
                  >
                    Unsubscribe
                  </button>
                  <div className="popupDiv col-12">
                    <button
                      className="btn btn-primary btn-pm-red"
                      type="button"
                      onClick={() => navigate("/home")}
                    >
                      CANCEL
                    </button>
                    &nbsp;&nbsp;
                    <button
                      className="btn btn-primary btn-pm-green"
                      type="button"
                      onClick={() => {
                        setSubStatus(104);
                        setPopup(true);
                      }}
                    >
                      LOGOUT
                    </button>
                  </div>
                </>
              ) : flow === "SUCCESS" ? (
                <>
                  {subMsg && (
                    <h3 className="login-title-green mb-3 mt-3 text-center">
                      {subMsg}
                    </h3>
                  )}
                  <h3 className="login-title mb-3 mt-3 text-center">
                    To access the service, click on below 'Click Here' button
                  </h3>
                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      <button
                        className="btn btn-primary btn-pm-custom"
                        type="button"
                        onClick={() => {
                          redirectTo("/home");
                        }}
                      >
                        Click Here
                      </button>
                      <div className="resend_otp">
                        <a
                          className="send_otp_link"
                          onClick={() => {
                            cancel("");
                          }}
                        >
                          {" "}
                          &lt;&lt;&nbsp;Back
                        </a>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <>
                  <h3 className="login-title mt-3 text-center">
                    Welcome to YoGamezBox
                  </h3>
                  <h3 className="login-title mt-1 text-center">
                    Enter your number to login on service
                  </h3>
                  <div className="phone-input">
                    <div className="has-validation input-group">
                      <div className="dialing-code">
                        <img
                          src={"/images/" + flag + ".svg"}
                          width="24"
                          alt="Cameroon"
                        />
                        <span>+{countryCode}</span>
                      </div>
                      <input
                        className="form-control form-mobile-no"
                        type="number"
                        inputMode="numeric"
                        value={phone ? phone : ""}
                        onChange={handleNumberChange}
                        placeholder="Enter Mobile Number"
                      />
                    </div>{" "}
                    <br />
                    <div className="has-validation input-group">
                      <div className="dialing-otp">
                        {isActive ? (
                          <span className="btn btn-pm-span">{seconds}s</span>
                        ) : (
                          <button
                            className="btn btn-pm-otp"
                            type="button"
                            onClick={sendOtp}
                            disabled={ButtonDisabled}
                          >
                            Get Code
                          </button>
                        )}
                      </div>
                      <input
                        className="form-control form-mobile-no"
                        type="number"
                        inputMode="numeric"
                        value={otp}
                        onChange={handleOtpChange}
                        placeholder="Enter verification code"
                      />
                    </div>
                    <br />
                    <div className="captcha">
                      <ReCAPTCHA
                        sitekey="6LcwFFArAAAAADFfR1TtZHzO-G42Ep9VPqrQySeD"
                        onChange={handleRecaptchaChange}
                        ref={recaptchaRef}
                      />
                      &nbsp;
                      <button className="btn btn-primary" onClick={handleReset}>
                        <i className="fas fa-repeat"></i>
                      </button>
                    </div>
                    {message.message && (
                      <div className="mb-3">
                        <p
                          className={`alert alert-${message.error ? "danger" : "success"}`}
                        >
                          {message.message}
                        </p>{" "}
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <button
                        className="btn btn-primary btn-pm-custom"
                        name="login"
                        onClick={confirmOtp}
                        disabled={ButtonLoginDisabled}
                      >
                        Login
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {popup && (
        <PopupSub
          subStatus={subStatus}
          plan={price[currency][plan - 1]}
          redirectTo={redirectTo}
          sub={subscribe}
          unsub={unsub}
          message={message}
        />
      )}
      {popupLoader && <Popup />}
    </>
  );
};

export default Ecoz;
